export const componentsHelper = (path) => {
  return {
    name: path,
    components: {
      desktop: () => import(/* webpackChunkName: "deskop" */ `../views/desktop/${path}`),
      mobile: () => import(/* webpackChunkName: "mobile" */`../views/mobile/${path}`)
    }
  }
}



// WEBPACK FOOTER //
// ./client/router/_helper.js